export default {
  title: 'Tu reseña nos ayuda mucho ❤️',
  description: '{{name}} en {{store}} — solo toca una estrella',
  buttons: {
    not_now: 'Ahora no',
    continue: 'Continuar',
  },
};
